import { useEffect, useState } from 'react';
import { readCookie } from './readCookie';
import { writeCookie } from './writeCookie';
export const useCookie = (name) => {
    const [value, setValue] = useState(() => {
        return readCookie(name);
    });
    const setCookie = (newValue, options) => {
        const didWrite = writeCookie(name, newValue, options);
        if (didWrite !== false) {
            setValue(newValue);
        }
    };
    useEffect(() => {
        setValue(readCookie(name));
    }, [name]);
    return [value, setCookie];
};
//# sourceMappingURL=useCookie.js.map
// @zapier/cookies@1.0.2 (aeccc3fd4)
